@if (data.purchaseRequisitionId && data.purchaseRequisitionNumber && processInstanceIds?.length) {
    <div class="px-2">
        <div class="row mb-3">
            <div class="col">
                <h2>
                    <em class="fas fa-eye pe-2"></em>
                    {{
                        'Prozess Status für Bedarfsmeldung \{\{purchaseRequisitionId\}\} '
                            | translate: { purchaseRequisitionId: this.data.purchaseRequisitionNumber }
                    }}
                </h2>
            </div>
            <div class="col-auto">
                <button mat-icon-button color="warn" (click)="dialogRef.close()">
                    <em class="fas fa-times fa-1_5x"></em>
                </button>
            </div>
        </div>
        @if (xml) {
            <div class="bpmn-viewer-container">
                <iim-bpmn-viewer [config]="config" [bpmnXml]="xml.value" [highlights]="highlights"></iim-bpmn-viewer>
            </div>
        }
    </div>
}
@if (!xml) {
    <div class="px-2 mb-4">
        <div class="row justify-content-center align-items-center h-100">
            <div class="col-auto">
                <iim-spinner size="medium" color="secondary"></iim-spinner>
            </div>
        </div>
    </div>
}
